import {SearchData} from "./search.data.model";
import {SearchCriteria} from "../../comp/search/search.criteria";

export class SearchDataAndCriteria {
  searchData: SearchData;
  searchCriteria: SearchCriteria;
}
